import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';
import { FormattedMessage } from '../Intl';
import EdapModuleView from '../EdapModuleView';
import { TALL_CAROUSEL_ASPECT_RATIO } from '../Carousel/constants';
import PropertyTypeCard from './PropertyTypeCard';
import { buildPropertyTypeSerpUrl } from './utils';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';
import {
  PROPERTY_TYPES_LINK_CLICK,
  PROPERTY_TYPES_CLICK_PREV,
  PROPERTY_TYPES_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

class PropertyTypes extends Component {
  static propTypes = {
    propertyTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
    siteName: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
    minCards: PropTypes.number,
    fetchPropertyTypeImages: PropTypes.func,
    propertyTypeImages: PropTypes.objectOf(PropTypes.string)
  };

  static defaultProps = {
    minCards: 5,
    propertyTypeImages: {}
  }

  componentDidMount() {
    if (this.hasPropertyTypes()) {
      this.props.fetchPropertyTypeImages();
    }
  }

  handlePreviousClick() {
    triggerEdapEvent(PROPERTY_TYPES_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(PROPERTY_TYPES_CLICK_NEXT);
  }

  hasPropertyTypes = () => {
    const { propertyTypes, minCards } = this.props;
    return propertyTypes && propertyTypes.length >= minCards;
  }

  render() {
    const {
      propertyTypes,
      siteName,
      destination,
      propertyTypeImages
    } = this.props;

    if (!this.hasPropertyTypes()) {
      return null;
    }

    return (
      <EdapModuleView
        eventOptions={MODULE_VIEW_EVENT_OPTIONS}
        tagName="section"
        className= "Content__section"
      >
        <FormattedMessage id={['module.propertytypes.title', 'module.propertytypes.tile.subtitle']}>
          {(propertyTypesTitle, propertyTypeSubtitle) => (
            <Carousel
              title={propertyTypesTitle}
              cardAspectRatio={TALL_CAROUSEL_ASPECT_RATIO}
              onPreviousClick={this.handlePreviousClick}
              onNextClick={this.handleNextClick}
              ssrEnabled // For SEO purposes
            >
              {propertyTypes.map(
                ({
                  propertyTypeKey,
                  formattedCount,
                  propertyTypeSerpFilter
                }, index) => (
                  <PropertyTypeCard
                    propertyTypeKey={propertyTypeKey}
                    key={index}
                    formattedCount={formattedCount}
                    imageUri={propertyTypeImages[propertyTypeKey] || ''}
                    clickUrl={buildPropertyTypeSerpUrl({ siteName, destination, propertyTypeSerpFilter })}
                    subtitleTemplate={propertyTypeSubtitle}
                    onClick={handleEdapClick(PROPERTY_TYPES_LINK_CLICK, { propertyTypeKey })}
                  />
                )
              )}
            </Carousel>
          )
          }
        </FormattedMessage>
      </EdapModuleView>
    );
  }
}

export default PropertyTypes;
